import { Dialog } from "@radix-ui/themes";
import { Instructions } from "./instructions";
import { MessageResponse } from "../api/hitl-api";

export function ErrorInstructionsModal({
  open,
  messageContent,
  onCancel,
}: {
  open: boolean;
  messageContent: MessageResponse["result"];
  onCancel: () => void;
}) {
  return (
    <Dialog.Root open={open}>
      <Dialog.Content
        className="py-0"
        style={{
          maxWidth: "100vw",
          padding: "0 1rem",
          border: "none",
          background: "transparent",
          boxShadow: "none",
          height: "100%",
          animation: "none",
        }}
      >
        <Instructions open={open} layout="modal" messageContent={messageContent} onCancel={onCancel} />
      </Dialog.Content>
    </Dialog.Root>
  );
}
